export default function getUrlTypePage(url,type) {
    // 站点枚举
    var res_type = 0;
    // 页面类型枚举
    var page_type = 0;
    if (url.indexOf("https://3d.3d66.com/") > -1 || url.indexOf("https://3dtest.3d66.com/") > -1) {
        res_type = 1;
        if (url == 'https://3d.3d66.com/' || url == 'https://3dtest.3d66.com/') {
            // 3D - 类目首页
            page_type = 2;
        } else if (url.indexOf("com/model/") > -1 && url.indexOf("sws=") == -1) {
            // 3D - 普通列表页
            page_type = 3;
        } else if (url.indexOf("com/model/") > -1 && url.indexOf("sws=") > -1) {
            // 3D - 搜索列表页
            page_type = 4;
        } else if (url.indexOf("/reshtmla/model/items/") > -1) {
            // 3D - 详情页
            page_type = 5;
        } else if (url == 'https://3d.3d66.com/collection' || url == 'https://3dtest.3d66.com/collection') {
            // 3D - 合辑列表页
            page_type = 6;
        } else if (/^https:\/\/3d\.3d66\.com\/collection\/\w+\.html$/.test(url) || /^https:\/\/3dtest\.3d66\.com\/collection\/\w+\.html$/.test(url)) {
            // 3D - 合辑详情页
            page_type = 7;
        }else if(url == 'https://3dtest.3d66.com/map_3d.html' || url == 'https://3d.3d66.com/map_3d.html'){
            page_type = 39;
        }else if(url.indexOf('https://3dtest.3d66.com/map/3d_') > -1 || url.indexOf('https://3d.3d66.com/map/3d_') > -1){
            page_type = 40;
        }else if(url.indexOf('https://3dtest.3d66.com/relation/list') > -1 || url.indexOf('https://3d.3d66.com/relation/list_') > -1){
            page_type = 41;
        }else if(url.indexOf('https://3dtest.3d66.com/relation/relation_') > -1 || url.indexOf('https://3d.3d66.com/relation/relation_') > -1){
            page_type = 42;
        }else if(url.indexOf('https://3dtest.3d66.com/relation/') > -1 || url.indexOf('https://3d.3d66.com/relation/') > -1){
            page_type = 43;
        }
    } else if (url.indexOf('https://www.3d66.com/sotu/search_result/index/1-') > -1 || url.indexOf('https://www_dybzp.3d66.com/sotu/search_result/index/1-') > -1) {
        //  3D - 图搜列表页
        res_type = 1;
        page_type = 8;
    }else if ((url.indexOf('https://www.3d66.com/material/home') > -1 || url.indexOf('https://www_dybzp.3d66.com/material/home') > -1) && url.indexOf("sws=") == -1) {
        // 材质首页
        res_type = 2;
        page_type = 2;
    }  else if ((url.indexOf('https://www.3d66.com/material/') > -1 || url.indexOf('https://www_dybzp.3d66.com/material/') > -1) && url.indexOf("sws=") == -1) {
        // 材质 - 普通列表页
        res_type = 2;
        page_type = 3;
    } else if ((url.indexOf('https://www.3d66.com/material/') > -1 || url.indexOf('https://www_dybzp.3d66.com/material/') > -1) && url.indexOf("sws=") > -1) {
        // 材质 - 搜索列表页
        res_type = 2;
        page_type = 4;
    } else if (url.indexOf('https://www.3d66.com/reshtmla/material/items') > -1 || url.indexOf('https://www_dybzp.3d66.com/reshtmla/material/items') > -1) {
        // 材质 - 搜索列表页
        res_type = 2;
        page_type = 5;
    } else if (url.indexOf('https://www.3d66.com/light/') > -1 || url.indexOf('https://www_dybzp.3d66.com/light/') > -1) {
        // 光网 - 普通列表页
        res_type = 3;
        page_type = 3;
    }else if (url.indexOf('https://www.3d66.com/reshtmla/light/items/') > -1 || url.indexOf('https://www_dybzp.3d66.com/reshtmla/light/items/') > -1) {
        // 光网 - 详情页
        res_type = 3;
        page_type = 5;
    } else if (url.indexOf('https://www.3d66.com/maxscript.html') > -1 || url.indexOf('https://www_dybzp.3d66.com/maxscript.html') > -1) {
        // 脚本 - 普通列表页
        res_type = 4;
        page_type = 3;
    } else if (url.indexOf("https://tietu.3d66.com/") > -1 || url.indexOf("https://tietutest.3d66.com/") > -1) {
        res_type = 5;
        if (url == 'https://tietu.3d66.com/' || url == 'https://tietutest.3d66.com/') {
            // 贴图 - 类目首页
            page_type = 2;
        } else if ((url.indexOf('https://tietu.3d66.com/tietu/') > -1 || url.indexOf('https://tietutest.3d66.com/tietu/') > -1) && url.indexOf("sws=") == -1) {
            // 贴图 - 普通列表页
            page_type = 3;
        } else if ((url.indexOf('https://tietu.3d66.com/tietu/') > -1 || url.indexOf('https://tietutest.3d66.com/tietu/') > -1) && url.indexOf("sws=") > -1) {
            // 贴图 - 搜索列表页
            page_type = 4;
        } else if (url.indexOf('https://tietu.3d66.com/reshtmla/tietu/items/') > -1 || url.indexOf('https://tietutest.3d66.com/reshtmla/tietu/items/') > -1) {
            // 贴图 - 详情页
            page_type = 5;
        } else if (url.indexOf('https://tietu.3d66.com/collection/list') > -1 || url.indexOf('https://tietutest.3d66.com/collection/list') > -1) {
            // 贴图 - 合辑详情页
            page_type = 7;
        } else if(url == 'https://tietutest.3d66.com/map_tietu.html' || url == 'https://tietu.3d66.com/map_tietu.html'){
            page_type = 39;
        }else if(url.indexOf('https://tietutest.3d66.com/map/tietu_') > -1 || url.indexOf('https://tietu.3d66.com/map/tietu_') > -1){
            page_type = 40;
        }else if(url.indexOf('https://tietutest.3d66.com/tietu_relation/list') > -1 || url.indexOf('https://tietu.3d66.com/tietu_relation/list') > -1){
            page_type = 41;
        }else if(url.indexOf('https://tietutest.3d66.com/tietu_relation/relation_') > -1 || url.indexOf('https://tietu.3d66.com/tietu_relation/relation_') > -1){
            page_type = 42;
        }else if(url.indexOf('https://tietutest.3d66.com/tietu_relation/') > -1 || url.indexOf('https://tietu.3d66.com/tietu_relation/') > -1){
            page_type = 43;
        }
    } else if (url.indexOf('https://www.3d66.com/sotu/search_result/index/5-') > -1 || url.indexOf('https://www_dybzp.3d66.com/sotu/search_result/index/5-') > -1) {
        // 贴图 - 图搜列表页
        res_type = 5;
        page_type = 8;
    }
    else if (url.indexOf('https://su.3d66.com/') > -1 || url.indexOf('https://sutest.3d66.com/') > -1) {
        res_type = 6;
        if (url == 'https://su.3d66.com/' || url == 'https://sutest.3d66.com/') {
            // SU - 类目首页
            page_type = 2;
        } else if ((url.indexOf('https://su.3d66.com/sketchup/') > -1 || url.indexOf('https://sutest.3d66.com/sketchup/') > -1) && url.indexOf("sws=") == -1) {
            // SU - 普通列表页
            page_type = 3;
        } else if ((url.indexOf('https://su.3d66.com/sketchup/') > -1 || url.indexOf('https://sutest.3d66.com/sketchup/') > -1) && url.indexOf("sws=") > -1) {
            // SU - 搜索列表页
            page_type = 4;
        } else if (url.indexOf('https://su.3d66.com/reshtmla/sketchup/items/') > -1 || url.indexOf('https://sutest.3d66.com/reshtmla/sketchup/items/') > -1) {
            // SU - 详情页
            page_type = 5;
        } else if (url == 'https://su.3d66.com/collection' || url == 'https://sutest.3d66.com/collection') {
            // SU - 合辑列表页
            page_type = 6;
        } else if (/^https:\/\/su\.3d66\.com\/collection\/\w+\.html$/.test(url) || /^https:\/\/sutest\.3d66\.com\/collection\/\w+\.html$/.test(url)) {
            // SU - 合辑详情页
            page_type = 7;
        }else if(url == 'https://sutest.3d66.com/map_su.html' || url == 'https://su.3d66.com/map_su.html'){
            page_type = 39;
        }else if(url.indexOf('https://sutest.3d66.com/map/su_') > -1 || url.indexOf('https://su.3d66.com/map/su_') > -1){
            page_type = 40;
        }else if(url.indexOf('https://sutest.3d66.com/sketchup_relation/list') > -1 || url.indexOf('https://su.3d66.com/sketchup_relation/list') > -1){
            page_type = 41;
        }else if(url.indexOf('https://sutest.3d66.com/sketchup_relation/relation_') > -1 || url.indexOf('https://su.3d66.com/sketchup_relation/relation_') > -1){
            page_type = 42;
        }else if(url.indexOf('https://sutest.3d66.com/sketchup_relation/') > -1 || url.indexOf('https://su.3d66.com/sketchup_relation/') > -1){
            page_type = 43;
        }
    }
    else if (url.indexOf('https://cad.3d66.com/') > -1 || url.indexOf('https://cadtest.3d66.com/') > -1) {
        res_type = 8;
        if (url == 'https://cad.3d66.com/' || url == 'https://cadtest.3d66.com/') {
            // CAD - 类目首页
            page_type = 2;
        } else if ((url.indexOf('https://cad.3d66.com/cad/') > -1 || url.indexOf('https://cadtest.3d66.com/cad/') > -1) && url.indexOf("sws=") == -1) {
            // CAD - 普通列表页
            page_type = 3;
        } else if ((url.indexOf('https://cad.3d66.com/cad/') > -1 || url.indexOf('https://cadtest.3d66.com/cad/') > -1) && url.indexOf("sws=") > -1) {
            // CAD - 搜索列表页
            page_type = 4;
        } else if (url.indexOf('https://cad.3d66.com/reshtmla/cad/items/') > -1 || url.indexOf('https://cadtest.3d66.com/reshtmla/cad/items/') > -1) {
            // CAD - 详情页
            page_type = 5;
        } else if (url.indexOf('https://cad.3d66.com/collection/list') > -1 || url.indexOf('https://cadtest.3d66.com/collection/list') > -1) {
            // CAD - 合辑详情页
            page_type = 7;
        }else if(url == 'https://cadtest.3d66.com/map_cad.html' || url == 'https://cad.3d66.com/map_cad.html'){
            page_type = 39;
        }else if(url.indexOf('https://cadtest.3d66.com/map/cad_') > -1 || url.indexOf('https://cad.3d66.com/map/cad_') > -1){
            page_type = 40;
        }else if(url.indexOf('https://cadtest.3d66.com/cad_relation/list') > -1 || url.indexOf('https://cad.3d66.com/cad_relation/list') > -1){
            page_type = 41;
        }else if(url.indexOf('https://cadtest.3d66.com/cad_relation/relation_') > -1 || url.indexOf('https://cad.3d66.com/cad_relation/relation_') > -1){
            page_type = 42;
        }else if(url.indexOf('https://cadtest.3d66.com/cad_relation/') > -1 || url.indexOf('https://cad.3d66.com/cad_relation/') > -1){
            page_type = 43;
        }
    }
    else if (url.indexOf('https://linggantu.3d66.com/') > -1 || url.indexOf('https://linggantutest.3d66.com/') > -1) {
        res_type = 9;
        if (url == 'https://linggantu.3d66.com/' || url == 'https://linggantutest.3d66.com/') {
            // 灵感图 - 类目首页
            page_type = 2;
        } else if ((url.indexOf('https://linggantu.3d66.com/lists/') > -1 || url.indexOf('https://linggantutest.3d66.com/lists/') > -1) && url.indexOf("sws=") == -1) {
            // 灵感图 - 普通列表页
            page_type = 3;
        } else if ((url.indexOf('https://linggantu.3d66.com/lists/') > -1 || url.indexOf('https://linggantutest.3d66.com/lists/') > -1) && url.indexOf("sws=") > -1) {
            // 灵感图 - 搜索列表页
            page_type = 4;
        } else if (url.indexOf('https://linggantu.3d66.com/items/') > -1 || url.indexOf('https://linggantutest.3d66.com/items/') > -1) {
            // 灵感图 - 详情页
            page_type = 5;
        } else if (url.indexOf('https://linggantu.3d66.com/collections') > -1 || url.indexOf('https://linggantutest.3d66.com/collections') > -1) {
            // 灵感图 - 合辑列表页
            page_type = 6;
        } else if (url.indexOf('https://linggantu.3d66.com/collection/index') > -1 || url.indexOf('https://linggantutest.3d66.com/collection/index') > -1) {
            // 灵感图 - 合辑详情页
            page_type = 7;
        }
    }
    else if (url.indexOf('https://xiaoguotu.3d66.com/') > -1 || url.indexOf('https://xiaoguotutest.3d66.com/') > -1) {
        res_type = 10;
        if (url == 'https://xiaoguotu.3d66.com/' || url == 'https://xiaoguotutest.3d66.com/') {
            // 效果图 - 类目首页
            page_type = 2;
        } else if ((url.indexOf('https://xiaoguotu.3d66.com/lists/') > -1 || url.indexOf('https://xiaoguotutest.3d66.com/lists/') > -1) && url.indexOf("sws=") == -1) {
            // 效果图 - 普通列表页
            page_type = 3;
        } else if ((url.indexOf('https://xiaoguotu.3d66.com/lists/') > -1 || url.indexOf('https://xiaoguotutest.3d66.com/lists/') > -1) && url.indexOf("sws=") > -1) {
            // 效果图 - 搜索列表页
            page_type = 4;
        } else if (url.indexOf('https://xiaoguotu.3d66.com/imghtml/items/') > -1 || url.indexOf('https://xiaoguotutest.3d66.com/imghtml/items/') > -1) {
            // 效果图 - 详情页
            page_type = 5;
        } else if (url.indexOf('https://xiaoguotu.3d66.com/collection/index') > -1 || url.indexOf('https://xiaoguotutest.3d66.com/collection/index') > -1) {
            // 效果图 - 合辑详情页
            page_type = 7;
        }
    }
    else if (url.indexOf('https://anli.3d66.com/') > -1 || url.indexOf('https://anlitest.3d66.com/') > -1) {
        res_type = 11;
        if (url == 'https://anli.3d66.com/' || url == 'https://anlitest.3d66.com/') {
            // 案例 - 类目首页
            page_type = 2;
        } else if ((url.indexOf('https://anli.3d66.com/lists/') > -1 || url.indexOf('https://anlitest.3d66.com/lists/') > -1) && url.indexOf("sws=") == -1) {
            // 案例 - 普通列表页
            page_type = 3;
        } else if ((url.indexOf('https://anli.3d66.com/lists/') > -1 || url.indexOf('https://anlitest.3d66.com/lists/') > -1) && url.indexOf("sws=") > -1) {
            // 案例 - 搜索列表页
            page_type = 4;
        } else if (url.indexOf('https://anli.3d66.com/imghtml/items/') > -1 || url.indexOf('https://anlitest.3d66.com/imghtml/items/') > -1) {
            // 案例 - 详情页
            page_type = 5;
        } else if (url.indexOf('https://anli.3d66.com/collection/') > -1 || url.indexOf('https://anlitest.3d66.com/collection/') > -1) {
            // 案例 - 合辑详情页
            page_type = 7;
        }
    }


    else if (url.indexOf('https://fanganwenben.3d66.com/') > -1 || url.indexOf('https://fanganwenbentest.3d66.com/') > -1) {
        res_type = 12;
        if (url == 'https://fanganwenben.3d66.com/' || url == 'https://fanganwenbentest.3d66.com/') {
            // 案例 - 类目首页
            page_type = 2;
        } else if ((url.indexOf('https://fanganwenben.3d66.com/lists/') > -1 || url.indexOf('https://fanganwenbentest.3d66.com/lists/') > -1) && url.indexOf("sws=") == -1) {
            // 案例 - 普通列表页
            page_type = 3;
        } else if ((url.indexOf('https://fanganwenben.3d66.com/lists/') > -1 || url.indexOf('https://fanganwenbentest.3d66.com/lists/') > -1) && url.indexOf("sws=") > -1) {
            // 案例 - 搜索列表页
            page_type = 4;
        } else if (url.indexOf('https://fanganwenben.3d66.com/imghtml/items/') > -1 || url.indexOf('https://fanganwenbentest.3d66.com/imghtml/items/') > -1) {
            // 案例 - 详情页
            page_type = 5;
        }
    }

    else if (url.indexOf('https://vr.3d66.com/') > -1 || url.indexOf('https://vrtest.3d66.com/') > -1) {
        res_type = 13;
        if (url == 'https://vr.3d66.com/' || url == 'https://vrtest.3d66.com/') {
            // 全景 - 首页
            page_type = 9;
        } else if (url.indexOf('https://vr.3d66.com/vr/index_detail') > -1 || url.indexOf('https://vr.3d66.com/vr/new_burn_after_reading') > -1 || url.indexOf('https://vrtest.3d66.com/vr/index_detail') > -1 || url.indexOf('https://vrtest.3d66.com/vr/new_burn_after_reading') > -1) {
            // 全景 - 详情页
            page_type = 5;
        } else if (url.indexOf('https://vr.3d66.com/vr/list.html') > -1 || url.indexOf('https://vrtest.3d66.com/vr/list.html') > -1) {
            // 全景 - 作品列表页
            page_type = 10;
        } else if (url.indexOf('https://vr.3d66.com/author/list.html') > -1 || url.indexOf('https://vrtest.3d66.com/author/list.html') > -1) {
            // 全景 - 设计师列表页
            page_type = 11;
        } else if (url.indexOf('https://vr.3d66.com/vr/edit_detail') > -1 || url.indexOf('https://vr.3d66.com/help.html') > -1 || url.indexOf('https://vrtest.3d66.com/vr/edit_detail') > -1 || url.indexOf('https://vrtest.3d66.com/help.html') > -1) {
            // 全景 - 全景工作台
            page_type = 12;
        } else if (url.indexOf('https://vr.3d66.com/author/new_homepage.html') > -1 || url.indexOf('https://vrtest.3d66.com/author/new_homepage.html') > -1) {
            // 全景 - 个人主页
            page_type = 13;
        }
    } else if (url.indexOf('https://user.3d66.com/vr/') > -1 || url.indexOf('https://usertest.3d66.com/vr/') > -1) {
        // 全景 - 全景工作台
        res_type = 13;
        page_type = 12;
    } else if (url == 'https://www.3d66.com/' || url == 'https://www.3d66.com/home' || url == 'https://www_dybzp.3d66.com/' || url == 'https://www_dybzp.3d66.com/home') {
        // 主站首页
        res_type = 14;
        page_type = 1;
    } else if (url == 'https://user.3d66.com/?new=1' || url == 'https://user.3d66.com/' || url == 'https://usertest.3d66.com/?new=1' || url == 'https://usertest.3d66.com/') {
        // 个人中心
        res_type = 15;
        page_type = 26;
    } else if (url.indexOf('https://user.3d66.com/homepage/') > -1 || url.indexOf('https://usertest.3d66.com/homepage/') > -1) {
        // 个人中心 - 个人主页
        res_type = 15;
        page_type = 13;
    } else if (url.indexOf('https://upload_file.3d66.com/upload/index/index') > -1 || url.indexOf('https://user.3d66.com/upload/index/index') > -1 || url.indexOf('https://upload_file_test.3d66.com/upload/index/index') > -1 || url.indexOf('https://usertest.3d66.com/upload/index/index') > -1) {
        // 上传中心 - 上传页
        res_type = 16;
        page_type = 14;
    } else if (url.indexOf('https://www.3d66.com/news.html') > -1 || url.indexOf('https://www_dybzp.3d66.com/news.html') > -1) {
        // 问答 - 咨询问答首页
        res_type = 17;
        page_type = 28;
    } else if (url.indexOf('https://www.3d66.com/answers/answers') > -1 || url.indexOf('https://www_dybzp.3d66.com/answers/answers') > -1) {
        // 问答 - 普通列表页
        res_type = 17;
        page_type = 3;
    } else if (url.indexOf('https://www.3d66.com/search/') > -1 || url.indexOf('https://www_dybzp.3d66.com/search/') > -1) {
        // 问答 - 搜索列表页
        res_type = 17;
        page_type = 4;
    } else if (url.indexOf('https://www.3d66.com/answers_relation/relation') > -1 || url.indexOf('https://www_dybzp.3d66.com/answers_relation/relation') > -1) {
        // 问答 - 标签列表页
        res_type = 17;
        page_type = 27;
    } else if (url.indexOf('https://www.3d66.com/answers/question_') > -1 || url.indexOf('https://www_dybzp.3d66.com/answers/question_') > -1) {
        // 问答 - 详情页
        res_type = 17;
        page_type = 5;
    } else if (url.indexOf('https://www.3d66.com/tiwen.html') > -1 || url.indexOf('https://www_dybzp.3d66.com/tiwen.html') > -1) {
        // 问答 - 提问页
        res_type = 17;
        page_type = 31;
    } else if (url.indexOf('https://www.3d66.com/map/answers_') > -1 || url.indexOf('https://www_dybzp.3d66.com/map/answers_') > -1) {
        // 问答 - 标签词聚合页
        res_type = 17;
        page_type = 32;
    } else if (url.indexOf('https://www.3d66.com/news/sucai_') > -1 || url.indexOf('https://www_dybzp.3d66.com/news/sucai_') > -1) {
        // 文章 - 普通列表页
        res_type = 18;
        page_type = 3;
    } else if (url.indexOf('https://www.3d66.com/news/') > -1 || url.indexOf('https://www_dybzp.3d66.com/news/') > -1) {
        // 文章 - 搜索列表页
        res_type = 18;
        page_type = 4;
    } else if (url.indexOf('https://www.3d66.com/sucai/') > -1 || url.indexOf('https://www_dybzp.3d66.com/sucai/') > -1) {
        // 文章 - 标签列表页
        res_type = 18;
        page_type = 27;
    } else if (url.indexOf('https://www.3d66.com/news/s_') > -1 || url.indexOf('https://www_dybzp.3d66.com/news/s_') > -1) {
        // 文章 - 详情页
        res_type = 18;
        page_type = 5;
    } else if (url.indexOf('https://www.3d66.com/map/sucai_') > -1 || url.indexOf('https://www_dybzp.3d66.com/map/sucai_') > -1) {
        // 文章 - 标签聚合页
        res_type = 18;
        page_type = 32;
    } else if (url.indexOf('https://user.3d66.com/recharge/new_charge') > -1 || url.indexOf('https://usertest.3d66.com/recharge/new_charge') > -1) {
        // 充值 - 溜币充值页
        res_type = 19;
        page_type = 18;
    } else if (url.indexOf('https://vip.3d66.com/') > -1 || url.indexOf('https://vip_test.3d66.com/') > -1) {
        // 充值 - VIP充值页
        res_type = 19;
        page_type = 19;
    } else if (url.indexOf('https://service.3d66.com/buy/xr_web.html') > -1 || url.indexOf('https://servicetest.3d66.com/buy/xr_web.html') > -1) {
        // 充值 - 渲染充值页
        res_type = 19;
        page_type = 20;
    } else if (url == 'https://ai.3d66.com/' || url == 'https://aitest.3d66.com/') {
        // AI - AI首页
        res_type = 20;
        page_type = 22;
    } else if (url.indexOf('https://ai.3d66.com/pro/Canvas') > -1 || url.indexOf('https://aitest.3d66.com/pro/Canvas') > -1) {
        // AI - AI创作页
        res_type = 20;
        page_type = 23;
    } else if (url.indexOf('https://ai.3d66.com/work/log') > -1 || url.indexOf('https://aitest.3d66.com/work/log') > -1) {
        // AI - 我的创作
        res_type = 20;
        page_type = 24;
    }else if(url == 'https://www_dybzp.3d66.com/map_material.html' || url == 'https://www.3d66.com/map_material.html'){
        res_type = 2;
        page_type = 39;
    }else if(url.indexOf('https://www_dybzp.3d66.com/map/material_') > -1 || url.indexOf('https://www.3d66.com/map/material_') > -1){
        res_type = 2;
        page_type = 40;
    }else if(url.indexOf('https://www_dybzp.3d66.com/material_relation/list') > -1 || url.indexOf('https://www.3d66.com/material_relation/list') > -1){
        res_type = 2;
        page_type = 41;
    }else if(url.indexOf('https://www_dybzp.3d66.com/material_relation/relation_') > -1 || url.indexOf('https://www.3d66.com/material_relation/relation_') > -1){
        res_type = 2;
        page_type = 42;
    }else if(url.indexOf('https://www_dybzp.3d66.com/material_relation/') > -1 || url.indexOf('https://www.3d66.com/material_relation/') > -1){
        res_type = 2;
        page_type = 43;
    }else if(url.indexOf('https://softwaretest.3d66.com/') > -1 || url.indexOf('https://software.3d66.com/') > -1){
        res_type = 22;
        page_type = 37;
        if(url == 'https://softwaretest.3d66.com/' || url == 'https://software.3d66.com/'){
            page_type = 3;
        }else if(url.indexOf('https://softwaretest.3d66.com/list/setup') > -1 || url.indexOf('https://software.3d66.com/list/setup') > -1){
            page_type = 0;
        }else if(url.indexOf('https://softwaretest.3d66.com/list/detail') > -1 || url.indexOf('https://software.3d66.com/list/detail') > -1){
            page_type = 5;
        }else if(url.indexOf('https://softwaretest.3d66.com/list') > -1 || url.indexOf('https://software.3d66.com/list') > -1){
            page_type = 3;
        }else if(url.indexOf('https://softwaretest.3d66.com/search_') > -1 || url.indexOf('https://software.3d66.com/search_') > -1){
            page_type = 4;
        }
    }

    if(type == 'res_type'){
        return res_type;
      }else{
        return page_type;
      }

}